module.exports = __webpack_public_path__ + "files/5fe6f5521149b2d2759fdd6027107e31.svg";